import {
  Component,
  Input,
  ViewChild,
  Signal,
  inject,
  computed,
  signal,
  output,
} from '@angular/core';
import { CommonModule } from '@angular/common';

import { TimingTowerService } from '../../timing-tower/timing-tower.service';

import { VbLxpVideoPlayerComponent } from '../video-player/vb-lxp-video-player.component';
import { StreamService } from '../../shared/stream.service';
import { RaceSessionService } from '../../timing-tower/race-session.service';
import { StreamData } from '../../shared/stream.token';

export type VideoSlotState = 'empty' | 'error' | 'playing';

@Component({
  selector: 'vb-lxp-video-slot',
  standalone: true,
  imports: [CommonModule, VbLxpVideoPlayerComponent],
  templateUrl: './video-slot.component.html',
  styleUrls: ['./video-slot.component.css'],
})
export class VbLxpVideoSlotComponent {
  public timingTowerService = inject(TimingTowerService);
  public streamService = inject(StreamService);
  public raceSessionService = inject(RaceSessionService);
  private readonly mvPlayerSignal = signal<VbLxpVideoPlayerComponent | undefined>(undefined);

  @Input() label = '';
  @Input() time = '0:00:00';
  @Input() isLive = true;
  @Input() showBadge = false;
  @Input() progressPercent = 55;
  @Input() volumePercent = 70;
  @Input() src = '';

  public playerClosed = output<StreamData>();

  @ViewChild('mvPlayer')
  set mvPlayer(player: VbLxpVideoPlayerComponent | undefined) {
    this.mvPlayerSignal.set(player);
  }

  get mvPlayer(): VbLxpVideoPlayerComponent | undefined {
    return this.mvPlayerSignal();
  }

  public state: Signal<VideoSlotState> = computed(() => {
    const player = this.mvPlayerSignal();

    if (!player) {
      return 'empty';
    }

    player.getStreamDataVersion();
    if (player.streamData) {
      return 'playing';
    } else {
      return 'empty';
    }
  });
  isPlaying = false;

  public onCloseClicked() {
    const streamData = this.mvPlayer?.streamData;

    if (!streamData) {
      return;
    }

    if (!streamData.carNumber) {
      this.streamService.isMainStreamSelected.set(false);
    } else {
      this.timingTowerService.setInactive(streamData.carNumber);
    }
    this.playerClosed.emit(streamData);
    this.mvPlayer.setStreamData(null);
  }
}
